import logo from './img/logo.png';

export const images = [
    logo
];